module.exports = __webpack_public_path__ + "static/media/final_da_mamada.d289e3db.jpg";